import { components } from 'react-select';

export const CustomSelectInput = (props) => {
  const customProps = { ...props };
  delete customProps.autoCorrect;
  delete customProps.autoCapitalize;

  return <components.Input {...customProps} />;
};
